// src/pages/CapitalBalance/index.js
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import CapitalBalanceFilters from "./components/CapitalBalanceFilters";
import CapitalBalanceTable from "./components/CapitalBalanceTable";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { exportCapitalBalanceCsv } from "./components/exportCapitalBalanceCsv";

const { Title } = Typography;

const CapitalBalance = () => {
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { filters, list, balanceTotal } = useSelector((state) => state.capitalBalance); // 👈 added list & balanceTotal
  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Capital Balance Report",
    removeAfterPrint: true,
  });
  const handleDownloadCsv = () => {
    exportCapitalBalanceCsv({
      list,
      balanceTotal,
      title:    "Capital Balance Report",
      filename: "capital_balance",
    });
  };

  const hasData = list.length > 0;

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <Title level={4} style={{ margin: 0 }}>
              Capital Balance Report
            </Title>
          }
            extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button
                type="primary"
                icon={<PrinterOutlined />}
                onClick={handlePrint}
              >
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <CapitalBalanceFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <CapitalBalanceTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Capital Balance Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <CapitalBalanceTable pagination={false} printMode />
          )}
        />
      </div>
    </div>
  );
};

export default CapitalBalance;
